/**
 * Permission identifiers for the unified scan/QR module (Issue #186).
 *
 * Mirrors `apps/api/src/auth/services/module-catalog.ts` so frontend nav
 * gating cannot diverge from the backend `@RequirePermission('scan',
 * 'resolve')` guard on `POST /api/v1/scan/resolve`.
 */
import { hasPermission } from './crmPermissions';

export const SCAN_PERMISSIONS = {
  RESOLVE: 'scan:resolve',
} as const;

export function canSeeScanMenu(permissions: readonly string[]): boolean {
  return hasPermission(permissions, SCAN_PERMISSIONS.RESOLVE);
}
